import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
interface Testimonial {
  name: string;
  location: string;
  role?: string;
  text: string;
}
interface TestimonialsProps {
  testimonials: Testimonial[];
}
export function Testimonials({
  testimonials
}: TestimonialsProps) {
  return <section className="w-full bg-white py-8 md:py-16" data-id="element-208">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-209">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-210">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-orange-50 border border-orange-200 rounded-lg p-6" data-id="element-211">
              <div className="flex gap-1 mb-4" data-id="element-212">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-orange-500 text-orange-500" data-id="element-213" />)}
              </div>
              <p className="text-gray-600 mb-4 leading-relaxed" data-id="element-214">
                "{testimonial.text}"
              </p>
              <div className="text-sm" data-id="element-215">
                <p className="text-gray-900 font-semibold" data-id="element-216">
                  {testimonial.name}
                </p>
                <p className="text-gray-500" data-id="element-217">
                  {testimonial.location}
                  {testimonial.role && ` · ${testimonial.role}`}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}